(function () {
  'use strict';

  var initialized = new WeakSet();
  var observedPrices = new WeakSet();

  function parseMoney(text) {
    var normalized = String(text || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var value = Number(normalized);
    return Number.isFinite(value) ? value : 0;
  }

  function initPrice(priceContainer) {
    var priceNode = priceContainer.querySelector('[data-price]');
    var compareNode = priceContainer.querySelector('[data-compare-price]');
    if (!priceNode || !compareNode) return;

    var savingNode = priceContainer.querySelector('.ff-product-price__saving');
    if (!savingNode) {
      savingNode = document.createElement('span');
      savingNode.className = 'ff-product-price__saving';
      savingNode.setAttribute('aria-live', 'polite');
      priceContainer.insertBefore(savingNode, priceContainer.querySelector('.unit-price'));
    }

    function updateSaving() {
      var price = parseMoney(priceNode.textContent);
      var compare = parseMoney(compareNode.textContent);
      var hasSaving = compare > price && price > 0;
      var nextText = hasSaving
        ? 'Ahorra $' + new Intl.NumberFormat('es-MX', { maximumFractionDigits: 0 }).format(compare - price)
        : '';

      if (savingNode.textContent !== nextText) savingNode.textContent = nextText;
      savingNode.hidden = !hasSaving;
    }

    updateSaving();
    if (observedPrices.has(priceContainer)) return;
    observedPrices.add(priceContainer);

    var observer = new MutationObserver(function () { updateSaving(); });
    observer.observe(priceNode, { childList: true, characterData: true, subtree: true });
    observer.observe(compareNode, { childList: true, characterData: true, subtree: true });
  }

  function initPrices(scope) {
    (scope || document).querySelectorAll('.product__meta .product__price').forEach(initPrice);
  }

  function dateFromParts(parts) {
    var values = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return {
      date: new Date(Date.UTC(values.year, values.month - 1, values.day, 12)),
      hour: values.hour || 0,
      minute: values.minute || 0
    };
  }

  function nthWeekday(year, monthIndex, weekday, nth) {
    var date = new Date(Date.UTC(year, monthIndex, 1, 12));
    var offset = (weekday - date.getUTCDay() + 7) % 7;
    date.setUTCDate(1 + offset + ((nth - 1) * 7));
    return date;
  }

  function key(date) {
    return [date.getUTCFullYear(), String(date.getUTCMonth() + 1).padStart(2, '0'), String(date.getUTCDate()).padStart(2, '0')].join('-');
  }

  function holidaysFor(year) {
    return new Set([
      year + '-01-01',
      key(nthWeekday(year, 1, 1, 1)),
      key(nthWeekday(year, 2, 1, 3)),
      year + '-05-01',
      year + '-09-16',
      key(nthWeekday(year, 10, 1, 3)),
      year + '-12-25'
    ]);
  }

  function isBusinessDay(date) {
    var day = date.getUTCDay();
    if (day === 0 || day === 6) return false;
    return !holidaysFor(date.getUTCFullYear()).has(key(date));
  }

  function addBusinessDays(date, amount) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < amount) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isBusinessDay(result)) added += 1;
    }
    return result;
  }

  function formatDate(date) {
    var formatted = new Intl.DateTimeFormat('es-MX', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    }).format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1).replace(/\./g, '');
  }

  function formatRange(start, end) {
    if (key(start) === key(end)) return formatDate(start);
    return formatDate(start) + ' – ' + formatDate(end);
  }

  function formatCountdown(minutes) {
    var hours = Math.floor(minutes / 60);
    var remainder = minutes % 60;
    if (hours === 0) return remainder + ' min';
    if (remainder === 0) return hours + ' h';
    return hours + ' h ' + remainder + ' min';
  }

  function initTimeline(root) {
    if (initialized.has(root)) return;
    initialized.add(root);

    var timezone = root.dataset.timezone || 'America/Mexico_City';
    var cutoff = Number(root.dataset.cutoffHour || 12);
    var orderNode = root.querySelector('[data-ff-order-date]');
    var processNode = root.querySelector('[data-ff-process-date]');
    var processCopy = root.querySelector('[data-ff-process-copy]');
    var arrivalNode = root.querySelector('[data-ff-arrival-date]');
    var liveNode = root.querySelector('[data-ff-live]');
    var methodSummary = root.querySelector('[data-ff-method-summary]');
    var methods = Array.prototype.slice.call(root.querySelectorAll('[data-ff-method]'));
    var schedule = null;
    var selectedMethod = null;

    function renderArrival() {
      if (!selectedMethod || !schedule) return;
      var minDays = Number(selectedMethod.dataset.minDays || 3);
      var maxDays = Number(selectedMethod.dataset.maxDays || 4);
      var minArrival = addBusinessDays(schedule.processEnd, minDays);
      var maxArrival = addBusinessDays(schedule.processEnd, maxDays);
      if (arrivalNode) arrivalNode.textContent = formatRange(minArrival, maxArrival);
    }

    function renderSchedule() {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var local = dateFromParts(parts);
      var orderDate = local.date;
      var beforeCutoff = isBusinessDay(orderDate) && local.hour < cutoff;
      var processStart = beforeCutoff ? orderDate : addBusinessDays(orderDate, 1);
      var processEnd = addBusinessDays(processStart, 1);
      var minutesRemaining = (cutoff * 60) - ((local.hour * 60) + local.minute);

      schedule = { processEnd: processEnd };
      if (orderNode) orderNode.textContent = formatDate(orderDate);
      if (processNode) processNode.textContent = formatRange(processStart, processEnd);
      if (processCopy) processCopy.textContent = beforeCutoff ? 'Preparación prioritaria' : 'Siguiente día hábil';
      if (liveNode) {
        liveNode.textContent = beforeCutoff
          ? 'Ordena en ' + formatCountdown(minutesRemaining) + ' para conservar esta estimación'
          : 'Asegura tu pedido hoy · preparación el siguiente día hábil';
      }
      renderArrival();
    }

    function selectMethod(button) {
      selectedMethod = button;
      methods.forEach(function (item) {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      if (methodSummary) methodSummary.textContent = button.dataset.summary || '';
      renderArrival();
    }

    methods.forEach(function (button) {
      button.addEventListener('click', function () { selectMethod(button); });
    });

    renderSchedule();
    var preferred = root.dataset.defaultMethod || 'standard';
    var initial = methods.find(function (button) { return button.dataset.ffMethod === preferred; }) || methods[0];
    if (initial) selectMethod(initial);

    var refreshTimer = window.setInterval(function () {
      if (!document.documentElement.contains(root)) {
        window.clearInterval(refreshTimer);
        return;
      }
      renderSchedule();
    }, 60000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ff-delivery]').forEach(initTimeline);
    initPrices(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
